var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([0bpt]|1r|1s|4p|6g|a2|ef|ft|hm|j3|ot|qe|qi|r0)|n([0367biq]|[9cw]5|23|2u|57|jx|ml|ya|ze)|2(57|5k|77|7y|8|ci|d6|g3|hd|k4)|f([46jlrx]|w[bin]|2j|4t|bm|d3|m4|n7|ob|pr|sl|to|vi)|q([04bw]|15|4j|6q|g9e|j7|k4|mc|mj|o9|v0|x6)|w(0q|1v|57|7i|a6|a9|cf|g|j|ry|v4|wb5|wf)|z([06abmtw]|51|dw|f4|gc|mu|nt|x5)|o([8wx]|15|4n|dj|f6|fo|hu|uh|uz|za|zc)|k([3fmr]|ya(|a)|1f|1z|4h|89|q9|r2|zb)|d([8eikz]|30|cm|f6|gb|nc|pi|v7)|l(9l|b0|cd|d|h5|iy|n7|t|u0|ym)|7([adjmqu]|2a|2d|5z|86|a2|fa|gn|ie|w3)|b([3oz]|84|am|kn|sc|vx|xt)|9([3glqz]|65|87|9u|am|be|e6|j2|ls|mq|og|p9)|r(02|7a|9f|gw|hk|j|ku|n6|oo|q7|xd|zx)|0([9dghjl]|1[5kq]|[aip]g|2j|4y|aj|bc|d3|fi|q9|vb|xz)|t([cdeq]|l(3|7|lv)|3a|3w|51|7lm|a6|ah|gm|ii|n9|ni|tk|ue)|i([05biku]|r[4iz]|10|4i|4z|99|a2|ap|c0|gs|kr|lw|ns|ot)|x([9dejlyz]|2y|4x|bv|gd|hy|mx|rh|ti|yc|zc)|h([16y]|a[58o]|4b|4c|cx|g2|j6|t8|up|wz|xj)|j([5iv]|w[bfj]|29|4f|a4|dp|dv|pn)|3([1ei]|71|92|fl|j3|r4|vu|wj|zr)|s([37bglr]|0a|56|61|c1|d9|ex|he|hs|kd|kj|me|qy|tz|vp)|v([9ns]|k[dhn]|b3|ct|fa|fg|og)|1([178iow]|00|f1|fk|i1|iz|jf|mh|mu|rv|x7)|8([2ehwx]|1s|e8|es|gu|hi|k29|nm|ov|qc|w4)|g(11|7v|9|d|xu|yb|yf|zt)|p([2cdsu]|3x|6o|n8|nr|yv)|4([0lnrv]|7[6eh]|17|1h|2a|bi|eg|ft|hs|pi|uu|v5)|a([fiw]|2r|3u|7h|7y|9o|ck|cv|do|eb|ikj|k3|mw|rf|up)|5([456kmnu]|0s|1p|6n|gc|rd|s9)|c([348]|23|4t|8a|kc|mi|n9)|6([13goqvz]|3t|8y|96|cd|co|fq|v8|vyp|yb)|u((|u|w)8|2l|c0|dt|gm|hn|wq)|e([59frtw]|2b|2f|5l|ah|av|hk|l9|lr|mz|tk3|vi|vw|wo)|y(2q|7n|81|ek|ji|kw|l8|x|y))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
